"use client";

import Image from "next/image";

interface ImageSkeletonProps {
  src: string;
  alt: string;
  className?: string;
}

export default function ImageSkeleton({
  src,
  alt,
  className,
}: ImageSkeletonProps) {
  return (
    <div className={className}>
      <Image
        src={src}
        alt={alt}
        width={800}
        height={600}
        quality={75}
        loading="lazy"
        className="mb-6 h-auto max-w-full rounded-[32px] object-cover"
      />
    </div>
  );
}
